import { IPhone } from '../../types/newbuilding/builder';

export function getFormattedPhone(phone?: IPhone | null): string {
  if (phone) {
    return `${phone.countryCode} (${phone.code}) ${phone.number.replace(/(\d{3})(\d{2})(\d{2})/, '$1-$2-$3')}`;
  }

  return '';
}
